// import dotenv from 'dotenv'
// dotenv.config();
export const API_URL = process.env.VUE_APP_URL;
export const TOKEN_SITE = process.env.VUE_APP_SITE;
export const FACEBOOK_APP_ID = process.env.VUE_APP_FACEBOOK_ID;
export const IS_CUSTOM = process.env.VUE_APP_IS_CUSTOM === "true";
// export const FACEBOOK_APP_ID = "457455332814858";
export default API_URL;
